import Page from "../../components/Page";

import "./styles.scss";

export default function Local() {
  return (
    <Page title="Nutrition & Medical Professionals">
      <h3>
        <b>National Directory of Plant-Based Medical Professionals</b>
      </h3>
      <br />
      <p>
        <b>Plant-Based Doctors</b> is a helpful, comprehensive directory of
        doctors, dietitians, and other medical professionals who focus on
        plant-based diet and lifestyle.
      </p>
      <br />
      <p>
        <b>Baltimore Area Nutrition Professionals</b>
      </p>
      <br />
      <p>
        <b>Mark Rifkin,</b> MS, RD, LDN
      </p>
      <p>
        Mark is a Registered Dietitian in private practice, who focuses on
        whole-food, plant-based diets to prevent and treat chronic conditions
        such as heart disease, diabetes, obesity, high blood pressure, and
        depression; MS in Health Education and has been conducting presentations
        on food-related topics since 1997; using good foods and great flavors,
        he also specializes in helping vegetarians and vegans optimize their
        eating habits; vegan since 1986. See Mark's web page at NO WEBPAGE. Join
        him on his Facebook group <b>"Ask a Vegan Dietitian"</b> Contact Mark at
        &nbsp;
        <a href="mailto:mark@balancednutritiononline.com">
          mark@balancednutritiononline.com
        </a>
        , or call 410-764-8343.
      </p>
      <br />
      <p>
        <b>Kevin Grodnitzky,</b> MS, RDN, CDE, LDN
      </p>
      <p>
        Kevin is a Registered Dietitian Nutritionist, Certified Diabetes
        Educator, and Certified Personal Trainer in private practice in
        Lutherville-Timonium, Baltimore, Maryland. Kevin has followed a plant
        based diet for over 20 years. He specializes in plant-based nutrition,
        weight loss, heart disease, diabetes, chronic kidney disease, irritable
        bowel syndrome, and sports nutrition. Kevin provides individualized
        nutrition coaching, customized meal plans, and expert guidance. Kevin
        can be reached at 410-989-1886 for a free 10 minute phone consult or at
        .
      </p>
      <br />
      <p>
        <b>Baltimore Area Traditional Medical Doctors</b>
      </p>
      <br />
      <p>
        <b>Joseph A. Adams,</b> MD, F.A.C.P.
      </p>
      <p>
        Joseph A. Adams, M.D. is a vegan internist and addiction medicine
        physician in the Baltimore area who works in a methadone program and
        does not see other patients. However, he maintains the website: , and is
        interested in promoting the treatment and prevention of disease, in
        part, through a whole food, plant based diet.{" "}
        <a href="mailto:joeadamdmd@gmail.com">joeadamdmd@gmail.com</a>
      </p>
      <br />
      <p>
        <b>Monica Aggarwal,</b> M.D.
      </p>
      <p>
        Monica Aggarwal is an experienced and skilled cardiologist and a member
        of The Heart Center at Mercy. She is Board Certified in Cardiovascular
        Disease and Internal Medicine and works with patients to diagnose, treat
        and prevent heart disease. She encourages people to adhere to a whole
        foods, plant-based diet. 410-332-9752
      </p>
      <br />
      <p>
        <b>Dana S. Simpler,</b> MD
      </p>
      <p>
        Dr. Simpler is Board Certified in Internal Medicine, and has been in
        private practice for 26 years in Baltimore City. She became vegan for
        the health benefits three years ago and has been promoting plant based
        eating to treat and prevent many common medical problems such as heart
        disease, cancer, diabetes, and autoimmune disease. Dr. Simpler is now
        doing conferences on the health benefits of a plant based diet in
        conjunction with 2 nutrition consultants - which includes cooking
        demonstrations and FOOD. Contact Dr. Simpler's office for the dates of
        upcoming conferences. 410-563-1700
      </p>
      <br />
      <p>
        <b>Baltimore Area Holistically Oriented Medical Doctors</b>
      </p>
      <br />
      <p>
        <b>Carol L. Bowman,</b> MD
      </p>
      <p>
        Dr. Bowman has dual board certification in both Internal and Holistic
        Medicine. She brings to Harford Holistic Center over 10 years of
        experience in the practice of Holistic Internal Medicine, combining the
        best of Western conventional medicine with time honored alternative
        therapies. 1318 E. Churchville Road, Bel Air, MD 21014. Call
        410-838-4407.
      </p>
      <br />
      <p>
        <b>Ariane Cometa,</b> MD
      </p>
      <p>
        The Cometa Wellness Center was founded by Dr. Ariane Cometa, a Board
        Certified Physician. The Center's mission is to provide a supportive
        environment where conventional medical training and complementary
        therapies combine to create wellness. 1300 York Road, Building D - Suite
        #290, Lutherville, MD 21093. Call 410-296-6100.{" "}
        <a
          href="http://www.cometawellnesscenter.com/"
          target="_blank"
          rel="noreferrer"
        >
          http://www.cometawellnesscenter.com//
        </a>
      </p>
      <br />
      <p>
        <b>Peter Hinderberger,</b> MD
      </p>
      <p>
        Peter Hinderberger, of the Ruscombe Mansion Community Health Center,
        focuses on promoting optimal wellbeing by providing health care through
        an integrated approach, combining conventional and complementary
        therapies, which include Anthroposophic medicine, homeopathy, and
        salutogenesis. 4801 Yellowwood Avenue, Baltimore, MD 21209 Phone:
        410.367.6263{" "}
      </p>
      <br />
      <p>
        <b>Baltimore Area Naturopathic Physicians</b>
      </p>
      <br />
      <p>
        <b>Stephany Porter,</b> ND
      </p>
      <p>
        Stephany Porter, ND, of the Bodhi Clinic, works to identify the cause of
        the problem, which could be internal (physical, emotional, spiritual,
        genetic) or external (social, environmental). She may employ a series of
        holistic naturopathic remedies such as botanical medicines, homeopathy,
        nutrients, bodywork, detoxification, diet and lifestyle options, before
        moving to more aggressive therapies. 701 Morris Tongue Drive
        Millersville, MD 21108 410-923-8888{" "}
        <a href="http://www.bodhiclinic.com/" target="_blank" rel="noreferrer">
          http://www.bodhiclinic.com/
        </a>{" "}
      </p>
    </Page>
  );
}
